import { PAS_VIDEO_ACTIV } from './video-flag';
import { PROTOCOL_DESCARCARE_ACTIV } from './protocol-flag';
import type { PasiInscriere } from './resolve-post-auth-target';

/**
 * Un singur loc care citeste ambele flag-uri de build ale wizardului (p8) si le da forma
 * ceruta de `resolvePostAuthTarget`. Fiecare apelant al resolverului trebuie sa treaca
 * `pasiInscriere: pasiInscriereActive()` in context -- fara ea, comportamentul e identic cu
 * cel de dinainte de p8 (`pasiInscriere` e optional in `PostAuthContext`).
 */
export function pasiInscriereActive(): PasiInscriere {
  return {
    videoActiv: PAS_VIDEO_ACTIV,
    protocolActiv: PROTOCOL_DESCARCARE_ACTIV,
  };
}
